import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Loader2, Plus, Trash2, Save, X } from "lucide-react";
import { toast } from "sonner";

const EMPTY = { slug: "", category: "", title: "", excerpt: "", body: "", affiliate_url: "", affiliate_label: "", is_published: true, order: 0 };

export default function AdminResources() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try { const { data } = await api.get("/admin/cms/resources"); setItems(data.items || []); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      if (items.find((x) => x.slug === editing.slug)) {
        await api.put(`/admin/cms/resources/${editing.slug}`, editing);
      } else {
        await api.post("/admin/cms/resources", editing);
      }
      toast.success("Saved"); setEditing(null); load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Save failed"); }
  };
  const del = async (slug) => {
    if (!window.confirm(`Delete ${slug}?`)) return;
    await api.delete(`/admin/cms/resources/${slug}`); toast.success("Deleted"); load();
  };

  return (
    <div data-testid="admin-resources">
      <div className="flex items-start justify-between flex-wrap gap-3">
        <div>
          <div className="dms-label mb-3">Resources</div>
          <h1 className="text-2xl sm:text-3xl font-heading font-bold text-[#0A2342]">Resource library</h1>
        </div>
        <button onClick={() => setEditing({ ...EMPTY })} className="dms-btn-primary"><Plus className="w-4 h-4" /> New article</button>
      </div>

      {editing && (
        <div className="mt-6 dms-card p-5 sm:p-6" data-testid="admin-resource-editor">
          <div className="flex items-center justify-between mb-4">
            <div className="dms-label">{items.find((x) => x.slug === editing.slug) ? "Edit article" : "New article"}</div>
            <button onClick={() => setEditing(null)} className="text-[#64748B]"><X className="w-4 h-4" /></button>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <input placeholder="slug-kebab" className="dms-input" value={editing.slug} onChange={(e) => setEditing({ ...editing, slug: e.target.value })} />
            <input placeholder="Category" className="dms-input" value={editing.category} onChange={(e) => setEditing({ ...editing, category: e.target.value })} />
            <input placeholder="Title" className="dms-input sm:col-span-2" value={editing.title} onChange={(e) => setEditing({ ...editing, title: e.target.value })} />
            <textarea placeholder="Excerpt" rows={2} className="dms-textarea sm:col-span-2" value={editing.excerpt} onChange={(e) => setEditing({ ...editing, excerpt: e.target.value })} />
            <textarea placeholder="Body (markdown - use ## for h2 and \\n\\n between paragraphs)" rows={10} className="dms-textarea sm:col-span-2" value={editing.body} onChange={(e) => setEditing({ ...editing, body: e.target.value })} />
            <input placeholder="Affiliate URL" className="dms-input" value={editing.affiliate_url || ""} onChange={(e) => setEditing({ ...editing, affiliate_url: e.target.value })} />
            <input placeholder="Affiliate button label" className="dms-input" value={editing.affiliate_label || ""} onChange={(e) => setEditing({ ...editing, affiliate_label: e.target.value })} />
            <input type="number" placeholder="Order" className="dms-input" value={editing.order} onChange={(e) => setEditing({ ...editing, order: Number(e.target.value) })} />
            <label className="flex items-center gap-2"><input type="checkbox" checked={editing.is_published} onChange={(e) => setEditing({ ...editing, is_published: e.target.checked })} /> Published</label>
          </div>
          <div className="mt-4 flex justify-end gap-2">
            <button onClick={() => setEditing(null)} className="dms-btn-ghost">Cancel</button>
            <button onClick={save} className="dms-btn-primary"><Save className="w-4 h-4" /> Save</button>
          </div>
        </div>
      )}

      <div className="mt-6 dms-card overflow-x-auto">
        <table className="w-full text-[13.5px]">
          <thead><tr className="text-left text-[11px] tracking-[0.2em] uppercase font-bold text-[#64748B] border-b border-[#E2E8F0]"><th className="p-3">Title</th><th className="p-3">Slug</th><th className="p-3">Category</th><th className="p-3">Order</th><th className="p-3">Published</th><th className="p-3" /></tr></thead>
          <tbody>
            {loading ? <tr><td colSpan={6} className="p-6 text-center"><Loader2 className="w-4 h-4 animate-spin inline" /></td></tr> :
             items.map((it) => (
              <tr key={it.slug} className="border-b border-[#E2E8F0] hover:bg-[#F8FAFC]">
                <td className="p-3 font-medium">{it.title}</td>
                <td className="p-3 font-mono text-xs">{it.slug}</td>
                <td className="p-3"><span className="dms-badge">{it.category}</span></td>
                <td className="p-3">{it.order}</td>
                <td className="p-3">{it.is_published ? "Yes" : "No"}</td>
                <td className="p-3 text-right">
                  <button onClick={() => setEditing({ ...it })} className="text-[12.5px] text-[#1D4E89] mr-3">Edit</button>
                  <button onClick={() => del(it.slug)} className="text-[12.5px] text-[#B91C1C]"><Trash2 className="w-3.5 h-3.5 inline" /></button>
                </td>
              </tr>
             ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
